var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.6C0 6.23969 0 4.55953 0.653961 3.27606C1.2292 2.14708 2.14708 1.2292 3.27606 0.653961C4.55953 0 6.23969 0 9.6 0H18.4C21.7603 0 23.4405 0 24.7239 0.653961C25.8529 1.2292 26.7708 2.14708 27.346 3.27606C28 4.55953 28 6.23969 28 9.6V18.4C28 21.7603 28 23.4405 27.346 24.7239C26.7708 25.8529 25.8529 26.7708 24.7239 27.346C23.4405 28 21.7603 28 18.4 28H9.6C6.23969 28 4.55953 28 3.27606 27.346C2.14708 26.7708 1.2292 25.8529 0.653961 24.7239C0 23.4405 0 21.7603 0 18.4V9.6Z",
    fill: "url(#paint0_linear_47_509)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21C18.9706 21 23 17.6421 23 13.5C23 9.35783 18.9706 5.99997 14 5.99997C9.02944 5.99997 5 9.35783 5 13.5C5 16.1255 6.61889 18.4359 9.0702 19.7758C8.98814 20.4427 8.74147 21.3326 8 22C9.40212 21.7476 10.5211 21.2404 11.3571 20.6714C12.1928 20.885 13.0803 21 14 21Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_509",
    x1: 14,
    y1: 0,
    x2: 14,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AF575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13BD2C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImessage);
export default __webpack_public_path__ + "static/media/imessage.3bf601546b1830cbb04dd70bbfead208.svg";
export { ForwardRef as ReactComponent };